import routerOptions0 from "/src/node_modules/.pnpm/nuxt@3.19.0_@parcel+watcher@2.5.1_@types+node@24.5.2_@vue+compiler-sfc@3.5.21_db0@0.3.2_837f92277022ac0a5f33d8e3a9f1bd26/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/src/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}